import {httpGet} from "../api/axios_api";
import Constants from "../../constants/constants"

export const actions = {
    RESET_RESULTS_STATE: "RESET_RESULTS_STATE",
    ADD_RESULTS_TO_LIST: "ADD_TO_RESULT_LIST",
    SHOULD_GET_RESULTS: "SHOULD_GET_RESULTS",
    START_GETTING_RESULTS: "START_GETTING_RESULTS",
    GET_MINUTES_PLAYED: "UPDATE_MINUTES_PLAYED"
};


export const resultsActions = {
    resetState: () => {
        return dispatch => {
            dispatch({
                type: actions.RESET_RESULTS_STATE
            })
        }
    },

    shouldGetResults: (flag) => {
        return dispatch => {
            dispatch({
                type: actions.SHOULD_GET_RESULTS,
                flag: flag
            })
        }
    },

    startGettingMinutesPlayedData: () => {
      return dispatch => {
        dispatch({
          type: actions.GET_MINUTES_PLAYED
        });
      }
    },

    startGettingResults: () => {
        return dispatch => {
            dispatch({
                type: actions.START_GETTING_RESULTS
            })
        }
    },

    getResults: (playerID, page, token) => {
        return dispatch => {
            let url = `${Constants.BACKEND_URL}/get-results/${playerID}/${page}`;
            httpGet(url, {}, token).then((response) => {
                if (response.data.success) {
                    dispatch({
                        type: actions.ADD_RESULTS_TO_LIST,
                        results: response.data.results
                    })
                }
                else {
                    //TODO: handle results load error
                }

            })
        }
    }
};


const initialState = {
    loaded: false,
    page: 0,
    done: false,
    getting_results: false,
    should_get_results: true,
    results: []
};

export default function reducer(state = initialState, action = {}) {
    switch (action.type) {
        case actions.RESET_RESULTS_STATE:
            return {
                ...state,
                loaded: false,
                page: 0,
                done: false,
                getting_results: false,
                should_get_results: true,
                results: []
            };
        case actions.SHOULD_GET_RESULTS:
            return {
                ...state,
                should_get_results: action.flag
            };
        case actions.START_GETTING_RESULTS:
            return {
                ...state,
                should_get_results: false,
                getting_results: true
            };
        case actions.ADD_RESULTS_TO_LIST:
            let done = false;
            if (action.results.length < Constants.RESULTS_PAGE_SIZE) {
                done = true;
            }

            return {
                ...state,
                results: state.results.concat(action.results),
                page: state.page + 1,
                done: done,
                loaded: true,
                should_get_results: false,
                getting_results: false
            };
        default:
            return state;
    }
}



// WEBPACK FOOTER //
// ./src/modules/views/result_view.js